var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var CAPITAL_A_INDEX = 65;
var CAPITAL_Z_INDEX = 90;
var LOWERCASE_A_INDEX = 97;
var LOWERCASE_Z_INDEX = 122;
/**
 * Generates alphabetical characters in order, starting from A and ending at Z.
 * After Z, the generator will start again at A.
 *
 * @example
 * 	const generator = alphabeticalCharacterGenerator();
 * 	generator.next().value; // "A"
 * 	generator.next().value; // "B"
 * 	generator.next().value; // "C"
 * 	...
 * 	generator.next().value; // "Z"
 * 	generator.next().value; // "A"
 */
export function upperCaseAlphabeticalCharacterGenerator() {
    return alphabeticalCharacterGenerator({
        firstIndex: CAPITAL_A_INDEX,
        lastIndex: CAPITAL_Z_INDEX,
    });
}
/**
 * Generates alphabetical characters in order, starting from a and ending at z.
 * After z, the generator will start again at a.
 *
 * @example
 * 	const generator = lowercaseAlphabeticalCharacterGenerator();
 * 	generator.next().value; // "a"
 * 	generator.next().value; // "b"
 * 	generator.next().value; // "c"
 * 	...
 * 	generator.next().value; // "z"
 * 	generator.next().value; // "a"
 */
export function lowerCaseAlphabeticalCharacterGenerator() {
    return alphabeticalCharacterGenerator({
        firstIndex: LOWERCASE_A_INDEX,
        lastIndex: LOWERCASE_Z_INDEX,
    });
}
function alphabeticalCharacterGenerator(props) {
    var firstIndex, lastIndex, index, isLastCharacter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                firstIndex = props.firstIndex, lastIndex = props.lastIndex;
                index = firstIndex;
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, String.fromCharCode(index)];
            case 2:
                _a.sent();
                isLastCharacter = index === lastIndex;
                if (isLastCharacter) {
                    index = firstIndex;
                }
                else {
                    index = index + 1;
                }
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
